export const WOLF_SIBLING_PAIR_KEY = 'wolf_siblings'
export const WOLF_SIBLING_SEAT_KEYS = ['wolf_elder', 'wolf_younger'] as const

export function isWolfSiblingSeatKey(key: string): boolean {
  return (WOLF_SIBLING_SEAT_KEYS as readonly string[]).includes(key)
}

export function expandWolfSiblingChoice(roleKey: string): string[] {
  return roleKey === WOLF_SIBLING_PAIR_KEY
    ? [...WOLF_SIBLING_SEAT_KEYS]
    : [roleKey]
}

export function countRoleSeats(roleKeys: ReadonlySet<string>): number {
  return [...roleKeys].reduce(
    (count, roleKey) => count + expandWolfSiblingChoice(roleKey).length,
    0,
  )
}

export function roleCountsForChoices(roleKeys: ReadonlySet<string>): Record<string, number> {
  const counts: Record<string, number> = {}
  for (const roleKey of roleKeys) {
    for (const seatRole of expandWolfSiblingChoice(roleKey)) {
      const role = /^werewolf_[2-4]$/.test(seatRole)
        ? 'werewolf'
        : seatRole
      counts[role] = (counts[role] ?? 0) + 1
    }
  }
  return counts
}
